import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {IActiveGameInstance} from "../../../interfaces/IActiveGameInstance";
import {GameInstanceService} from "../../../services/game-instance.service";
import {ErrorHandlingService} from "../../../services/error-handling.service";
import {UIStateEnum} from "../../../enum/UIStateEnum";
import {DialogBaseComponent} from "../dialog-base/dialog-base.component";
import {PipesModule} from "../../../pipes/pipes.module";
import {MatButton} from "@angular/material/button";
import {IGameQueryResult} from "../../../interfaces/IGameQueryResult";
import {IStopGame} from "../../../interfaces/IStopGame";
import {IApiErrorResponse} from "../../../interfaces/error/IApiErrorResponse";
import {SnackbarService} from "../../../services/snackbar.service";
import {IEndGame} from "../../../interfaces/IEndGame";
import {ActiveUserService} from "../../../services/active-user.service";
import {GameService} from "../../../services/game.service";


@Component({
  selector: 'app-end-game-dialog',
  standalone: true,
  imports: [
    DialogBaseComponent,
    PipesModule,
    MatButton
  ],
  templateUrl: './end-game-dialog.component.html',
  styleUrl: './end-game-dialog.component.css'
})
export class EndGameDialogComponent implements OnInit {

  public uiState = UIStateEnum.ShowLoading;
  public uiStateEnumForTemplate = UIStateEnum;

  public totalStripeFees: number = 0;

  constructor(private matDialogRef: MatDialogRef<EndGameDialogComponent>,
              private gameInstanceService: GameInstanceService,
              private gameService: GameService,
              private activeUserService: ActiveUserService,
              private errorHandlingService: ErrorHandlingService,
              private snackBarService: SnackbarService,
              @Inject(MAT_DIALOG_DATA) private data: {
                draw: IActiveGameInstance | null,
                game: IGameQueryResult
              }) { }

    ngOnInit(): void {
        if (!this.data.draw) {
          this.uiState = UIStateEnum.ShowData;
          this.snackBarService.openErrorSnackBar('No active draw found. Cannot end the game.');
          this.matDialogRef.close();
          return;
        }

        this.gameInstanceService.getTotalStripeFees(this.data.draw.Id).subscribe({
          next: (resultP) => {
            this.uiState = UIStateEnum.ShowData;
            this.totalStripeFees = resultP.StripeFeesForGameInstance;
          }, error: (err) => {
            this.uiState = UIStateEnum.ShowData;
            this.errorHandlingService.displayPageLevelErrorMessage(err, 'There was an issue retrieving the total stripe fees for the current draw.');
          }
        });
    }

    submit(): void {
      if (!this.data.draw) {
        this.snackBarService.openErrorSnackBar('No active draw found. Cannot end the game.');
        return;
      }

      this.uiState = UIStateEnum.ShowLoading;

      let command: IEndGame = {
        AdminId: this.activeUserService.activeUser().Id,
        GameId: this.data.game.Id,
        GameInstanceId: this.data.draw.Id
      }

      this.gameService.endGame(command).subscribe({
        next: () => {
          this.matDialogRef.close();
          this.snackBarService.openSuccessfulSnackBar('Successfully ended the game.');
        }, error: (res: IApiErrorResponse) => {
          this.uiState = UIStateEnum.ShowData;
          if (res.Error?.ClientErrorMessages?.length > 0) {
            this.snackBarService.openErrorSnackBar(res.Error.ClientErrorMessages.toString());
          } else {
            this.snackBarService.openErrorSnackBar('There was an error ending the game');
          }
        }
      })
    }

}
